import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import  * as XLSX  from 'xlsx';
import { environment } from '../../../../environments/environment';


import {
  ColDef,
  CellValueChangedEvent,
  RowValueChangedEvent,
  ICellEditorComp,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-enterprise';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { GridService } from 'src/app/_services/grid.service';
import * as moment from 'moment';

@Component({
  selector: 'app-target-edit',
  templateUrl: './target-edit.component.html',
  styleUrls: ['./target-edit.component.css'],
  providers: [ConfirmationService, MessageService]
})

export class TargetEditComponent implements OnInit {
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  societalist:any[]=[];
  societasel;
  allaDataSel:Date;
  dallaDataSel:Date;
  caricaOspiti=false;
  showCaricaTargets=false;
  operazioniItems: MenuItem[];
  myReader:FileReader = new FileReader();
  XLSX: any;

  public editType = 'fullRow';
  public columnDefs: ColDef[] = [
    { field: 'id', hide: true },
    
    { field: 'name',  editable: true, headerName:'Name',cellEditor: 'agTextCellEditor'},
    { field: 'surname',  editable: true, headerName:'Surname',cellEditor: 'agTextCellEditor'},
    { field: 'mobile',editable: true, headerName:'Mobile',cellEditor: 'agTextCellEditor'},
    { field: 'email',editable: true, headerName:'Email',cellEditor: 'agTextCellEditor'},
   
    { field: 'rsa',editable: true, headerName:'Residence',cellEditor: 'agTextCellEditor'},
    { field: 'num_ind_email',editable: false, maxWidth:200,minWidth:200, headerName:'Num. email address'},
    { field: 'id',  
      headerName: '', 
      editable: false,
      sortable:false,
      maxWidth:150,
      minWidth:150,
      cellRenderer: params =>    {   

        return '<a title="Delete row" style="cursor:pointer;"><i class=" pl-2 feather ft-trash pointer"></i> Remove</a>'; 

      },
      onCellClicked:function(data){ 
        _this.gridApi.applyTransaction({
          remove: [data.data]
        });
      }   
    },
  ];
  showQR=false;
  QrCode='';

  isEditing=false;
  action='';  
  ID:number;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

  breadcrumbs: MenuItem[];
  gridApi:any;
  target:any={
    id:'',
    name:'',
    website:'',
    targetlist:[]
  };
  


  errors: {
    targetNameError: boolean,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private messageService: MessageService,
    public globalService: GlobalService,
    public gridService: GridService,
  ) { }

  ngOnInit(): void {
    _this=this;
    this.initErrors();  
    this.operazioniItems=[
      {
        label:'Carica ospiti', 
        command: () => {
          this.apiService.get('surveys/societalistallgamma',{}).subscribe(data => {
            this.societalist=data.Result;
            this.caricaOspiti=true;
            this.showCaricaTargets=true;
          });
         
        }
      },
      {
        label:'Carica dipendenti', 
        command: () => {
          this.apiService.get('surveys/societalistall',{}).subscribe(data => {
            this.societalist=data.Result;
            this.caricaOspiti=false;
            this.showCaricaTargets=true;
          });
     
        }
      },
      {
        label:'Svuota elenco', 
        command: () => {
          this.azzera();
        }
      },
    ];
    this.action=this.route.snapshot.paramMap.get('action');
    this.ID=null;
    if (this.route.snapshot.paramMap.get('id')) {
        this.ID=parseInt(this.route.snapshot.paramMap.get('id'));
        this.apiService.get('surveys-targets/listall',{}).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==this.ID){
              this.target=g;
            }
          }
        });
    }
 
  }

  
  private initErrors() {
    this.errors = {} as any;
    this.errors.targetNameError = false;

  }

  private validate() : boolean {
    let isValid : boolean = true;
    
    if (this.target.name=='') {
      this.errors.targetNameError = true;
      isValid = false;
    }
    return isValid;
  }


  save(){
    this.initErrors();
    if (!this.validate()) return;
    if(this.ID){
      this.target.id=this.ID;
    } else {
      delete this.target['id'];
    }
   
    this.target.targetlist=[];
   
    this.gridApi.forEachNode((node) =>{
   

      if((node.data)&&(node.data.name)&&(node.data.surname)&&(node.data.name!='')&&(node.data.surname!='')){
        if(!node.data.mobile){
          node.data.mobile='';
        }
        if(!node.data.email){
          node.data.email='';
        }
        this.target.targetlist.push(node.data);
      }
      
    });

    this.apiService.updatetarget(this.target).subscribe(data => {
      this.addSingle('success', 'Successo', 'Saved');
   //   this.router.navigateByUrl('/dashboard/surveys/targets');
    });
  }
  
  addRow()
  {
    let row={
      Id:'-1',
      name:'',
      surname:'',
      mobile:'',
      email:'',
      rsa:'',
    };
    const transaction = {
      add: [row]
    };
    this.gridApi.applyTransaction(transaction);
    let rowDatalength = 0;
    this.gridApi.forEachNode(node => rowDatalength++);
    this.gridApi.startEditingCell({
      rowIndex: rowDatalength-1,
      colKey: 'id',
    });
  }
  
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


  onGridReady(params: GridReadyEvent) {
    params.api.showLoadingOverlay();
    this.gridApi = params.api;
  }
  
  onrowEditingStopped($event) {
  
      this.isEditing=false;
   
  }
  onRowEditingStarted($event) {
  
  }
  onCellValueChanged(event:CellValueChangedEvent) {
  }

  onRowValueChanged(event:RowValueChangedEvent) {

  }
  chiudiQR(){
    this.showQR=false;
  }

  changeListener($event) : void {
    this.readThis($event.files[0]);
  }

  readThis(file:File) : void {
   
    

    this.myReader.onloadend = (e)=>{
      // you can perform an action with readed data here

      var workbook = this.convertDataToWorkbook(this.myReader.result);

    this.populateGrid(workbook);
    }

    this.myReader.readAsArrayBuffer(file);
    
  }

  convertDataToWorkbook(dataRows) {
    /* convert data to binary string */
    var data = new Uint8Array(dataRows);
    var arr = [];

    for (var i = 0; i !== data.length; ++i) {
      arr[i] = String.fromCharCode(data[i]);
    }

    var bstr = arr.join('');

    return XLSX.read(bstr, { type: 'binary' });
  }


 populateGrid(workbook: any) {
  // our data is in the first sheet
  var firstSheetName = workbook.SheetNames[0];
  var worksheet = workbook.Sheets[firstSheetName];

  // we expect the following columns to be present
  var columns: Record<string, string> = {
    A: 'name',
    B: 'surname',
    C: 'mobile',
    D: 'email',
    E: 'rsa',
  };

  var rowData = [];

  // start at the 2nd row - the first row are the headers
  var rowIndex = 2;

  // iterate over the worksheet pulling out the columns we're expecting
  var counter=0;
  while (worksheet['A' + rowIndex]) {
    var row: any = {};
    Object.keys(columns).forEach(function (column) {
      if(worksheet[column + rowIndex]){
        row[columns[column]] = worksheet[column + rowIndex].w;
      }else {
        row[columns[column]] = '';
      }
    
    
    });
    row['id'] = counter;
    rowData.push(row);
    counter++;
    rowIndex++;
  }

  // finally, set the imported rowData into the grid
 // this.gridApi.setRowData(rowData);
 this.target.targetlist=rowData;
 this.gridApi.redrawRows();
}
downloadmodel(){
  
  window.open(environment.QUESTIONARI_URL+'targetsmodel.xlsx', '_blank').focus();
}
azzera(){
  this.target.targetlist=[];
  this.gridApi.redrawRows();
}
  loaddip(){

    this.apiService.get('surveys/targetspersocietalistall',{idSocieta:this.societasel}).subscribe(data => {
  
      this.target.targetlist=this.target.targetlist.concat(data.Result);
      this.gridApi.redrawRows();
      this.showCaricaTargets=false;
    });
   
  }
loadtargets(){
  let societa=this.societasel;
 
  if(!this.dallaDataSel) return;
  if(!this.allaDataSel) return;
  this.societasel=null;
  if(this.caricaOspiti){
    let params={
      periodfrom:moment(this.dallaDataSel).format('YYYY-MM-DD'),
      periodto:moment(this.allaDataSel).format('YYYY-MM-DD'),
      idSocieta:societa
    }
    this.apiService.get('surveys/ospitipersocietalistall',params).subscribe(data => {
     //this.apiService.get('surveys/ospitiperrecuperoemail',params).subscribe(data => {
      this.target.targetlist=this.target.targetlist.concat(data.Result);
      this.gridApi.redrawRows();
      this.showCaricaTargets=false;
    });
  } else {
    this.apiService.get('surveys/dipendentipersocietalistall',{idSocieta:societa}).subscribe(data => {
  
      this.target.targetlist=this.target.targetlist.concat(data.Result);
      this.gridApi.redrawRows();
      this.showCaricaTargets=false;
    });
  }
 
   
}

}

var _this;